const axios = require("axios");

// const { jsPDF } = require("jspdf");

// window.jsPDF = jsPDF;

isValidEmail = function (email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

terbilangRupiah = function (bilangan) {
    bilangan = String(bilangan);
    var angka = new Array(
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0",
        "0"
    );
    var kata = new Array(
        "",
        "satu",
        "dua",
        "tiga",
        "empat",
        "lima",
        "enam",
        "tujuh",
        "delapan",
        "sembilan"
    );
    var tingkat = new Array("", "ribu", "juta", "milyar", "triliun");

    var panjang_bilangan = bilangan.length;

    /* pengujian panjang bilangan */
    if (panjang_bilangan > 15) {
        kaLimat = "Diluar Batas";
        return kaLimat;
    }

    /* mengambil angka-angka yang ada dalam bilangan, dimasukkan ke dalam array */
    for (i = 1; i <= panjang_bilangan; i++) {
        angka[i] = bilangan.substr(-i, 1);
    }

    i = 1;
    j = 0;
    kaLimat = "";

    /* mulai proses iterasi terhadap array angka */
    while (i <= panjang_bilangan) {
        subkaLimat = "";
        kata1 = "";
        kata2 = "";
        kata3 = "";

        /* untuk Ratusan */
        if (angka[i + 2] != "0") {
            if (angka[i + 2] == "1") {
                kata1 = "seratus";
            } else {
                kata1 = kata[angka[i + 2]] + " ratus";
            }
        }

        /* untuk Puluhan atau Belasan */
        if (angka[i + 1] != "0") {
            if (angka[i + 1] == "1") {
                if (angka[i] == "0") {
                    kata2 = "sepuluh";
                } else if (angka[i] == "1") {
                    kata2 = "sebelas";
                } else {
                    kata2 = kata[angka[i]] + " belas";
                }
            } else {
                kata2 = kata[angka[i + 1]] + " puluh";
            }
        }

        /* untuk Satuan */
        if (angka[i] != "0") {
            if (angka[i + 1] != "1") {
                kata3 = kata[angka[i]];
            }
        }

        /* pengujian angka apakah tidak nol semua, lalu ditambahkan tingkat */
        if (angka[i] != "0" || angka[i + 1] != "0" || angka[i + 2] != "0") {
            subkaLimat =
                kata1 + " " + kata2 + " " + kata3 + " " + tingkat[j] + " ";
        }

        /* gabungkan variabe sub kaLimat (untuk Satu blok 3 angka) ke variabel kaLimat */
        kaLimat = subkaLimat + kaLimat;
        i = i + 3;
        j = j + 1;
    }

    /* mengganti Satu Ribu jadi Seribu jika diperlukan */
    if (angka[5] == "0" && angka[6] == "0") {
        kaLimat = kaLimat.replace("satu ribu", "seribu");
    }

    // return kaLimat + "Rupiah";
    kaLimat = kaLimat.replace(/  +/g, " ");
    return kaLimat;
};

showPopup = function (text, cond = false) {
    Toastify({
        text: text,
        duration: 3000,
        gravity: "top",
        position: "center",
        backgroundColor: cond ? "#4fbe79" : "#f44336",
    }).showToast();
    // if (cond) {
    //     var popup = $("#popup, #popup-success");
    // } else {
    //     var popup = $("#popup");
    // }

    // popup.text(text);
    // popup.fadeIn();

    // // Fade out the popup after 2 seconds
    // setTimeout(function () {
    //     popup.fadeOut();
    // }, 2000); // 2000 milliseconds = 2 seconds
};

copyToClipboard = function (text, notif) {
    navigator.clipboard
        .writeText(text)
        .then(function () {
            showPopup(notif, true);
        })
        .catch(function (error) {
            console.error("Failed to copy text: ", error);
        });
};

toFormData = function (obj) {
    const formData = new FormData();

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];

            // Exclude null and undefined values
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        }
    }

    return formData;
};

previewTemplate = function () {
    return `<div class="dz-preview dz-file-preview">
    <div class="dz-details">
        <div class="dz-thumbnail">
            <img data-dz-thumbnail>
            <span class="dz-nopreview">No preview</span>
            <div class="dz-success-mark"></div>
            <div class="dz-error-mark"></div>
            <div class="dz-error-message"><span data-dz-errormessage></span></div>
            <div class="progress">
            <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" data-dz-uploadprogress></div>
            </div>
        </div>
        <div class="dz-filename" data-dz-name></div>
        <div class="dz-size" data-dz-size></div>
        </div>
        </div>`;
};

$(document).ready(function () {
    $(".bottom-nav-child").on("click", function () {
        if ($(this).hasClass("actived") == false) {
            $(".bottom-nav-child").removeClass("actived");
            $(".bottom-nav-child")
                .siblings(".bottom-nav-child-list")
                .removeClass("actived");
            $(this).siblings(".bottom-nav-child-list").addClass("actived");
            $(this).addClass("actived");
        } else {
            if (
                $(this)
                    .siblings(".bottom-nav-child-list")
                    .hasClass("actived") == false
            ) {
                $(this).siblings(".bottom-nav-child-list").addClass("actived");
            } else {
                $(this)
                    .siblings(".bottom-nav-child-list")
                    .removeClass("actived");
            }
        }
    });

    $("#togglePassword").on("click", function () {
        // Get the input field and its type
        const passwordField = $("#password");
        const icon = $(this).children("toggleNpwpd");
        const npwpdValue =
            passwordField.attr("type") === "password" ? "text" : "password";
        if (npwpdValue.text() === "************") {
            npwpdValue.text('{{ $userData["NPWPD"] ?? "************" }}');
            icon.removeClass("ti-eye-off").addClass("ti-eye");
        } else {
            npwpdValue.text("************");
            icon.removeClass("ti-eye").addClass("ti-eye-off");
        }
    });
});
